import React, { useContext } from 'react'
import { COMPUTED_SUBSTITUTIONS } from 'Pages/GMS/ARS/ARSConstants';
import Tabs from '../../../../Components/Common/components/Tabs';
import ComputedSubstitutionComponent from './ComputedSubstitutionView';
import { computedSubstitutionTabs } from '../constants/CSConstants';
import { IterationContext, IterationContextProvider, IterationContextType } from '../contexts/IterationContext';
import { toast } from 'react-toastify';
import { AppContext } from 'Context/AppContext';
import { useHistory } from 'react-router-dom';
import IterationTable from '../components/iteration/IterationTable';

const CSView = () => {
    return (
        <IterationContextProvider>
            <CSTabView isSidePanel={false} />
        </IterationContextProvider>
    );
}

export default CSView

type CSTabViewProps = { isSidePanel: boolean }

const CSTabView = ({ isSidePanel }: CSTabViewProps) => {
    const { activeTab, onTabChange } = useContext<IterationContextType>(IterationContext);
    const appData = useContext(AppContext);
    const history = useHistory();
    const { readPermission } = useContext<IterationContextType>(IterationContext);
    const tabLabels: Record<ComputedSubstitutionTabType, string> = {
        'iteration': 'Iteration Method',
        'weightage': 'Weightage Method'
    };

    const handleCreate = () => {
        if (!readPermission) {
            toast.error("You don't have permission to create iteration method")
            return;
        }

        if (activeTab === "weightage") { createWeigtage() }
        else { createIteration() }
    }

    const createWeigtage = () => {
        if (!appData?.pm?.checkPermission("computedsubstitution_create")) {
            toast.info("You dont have permission for this operation")
            return
        }
        history.push("/gms/computed_substitutions/create/null/null")
    }

    const createIteration = () => {
        if (!appData?.pm?.checkPermission("computedsubstitution_create")) {
            toast.info("You dont have permission for this operation")
            return
        }
        history.push("/gms/computed_substitutions_iteration/create")
    }

    return (
        <>
            <div className='tw-bg-[#FAFAFC] tw-w-full'>
                <h1 id="cs-title" className="tw-text-left tw-text-[#091E42] tw-font-semibold tw-text-[28px] tw-my-3.5">
                    {COMPUTED_SUBSTITUTIONS}
                </h1>
            </div>
            <div className="tw-w-full tw-h-0 tw-outline tw-outline-1 tw-outline-offset-[-0.50px] tw-outline-zinc-300"></div>

            <div className="tw-flex tw-justify-between tw-items-end">
                <Tabs<ComputedSubstitutionTabType>
                    tabs={computedSubstitutionTabs}
                    activeTab={activeTab}
                    onTabChange={onTabChange}
                    labels={tabLabels}
                />
                <button onClick={handleCreate} className={`button-style tw-w-max tw-my-2`}>
                    {"Create"}
                </button>
            </div>
            <div className="tw-w-full tw-h-0 tw-outline tw-outline-1 tw-outline-offset-[-0.50px] tw-outline-zinc-300"></div>

            {activeTab === "weightage" ? <ComputedSubstitutionComponent isSidePanel={isSidePanel} /> : <IterationTable />}
        </>
    )
}

